import React from "react";

const Navlinks = () => {
  return (
    <>
      <li>OUR PRODUCTS</li>
      <li>ABOUT US</li>
      <li>LIVE BETTER</li>
      <li>CLAIMS & SUPPORT</li>
      <li>MY ACCOUNT</li>
    </>
  );
};

export default Navlinks;
